function mergeById(objects1: any, objects2: any) {
  let objectsMerged = objects2;
  objects1.forEach((object1: any) => {
    let thereis = false;
    objectsMerged.forEach((object: any) => {
      if (object.guid === objects1.guid) {
        thereis = true;
      }
    });
    if (!thereis) {
      objectsMerged.push(object1);
    }
  });
  return objectsMerged;
}
function uniqueArray2(arr: any) {
  var a = [];
  for (var i = 0, l = arr.length; i < l; i++)
    if (a.indexOf(arr[i]) === -1 && arr[i] !== '') a.push(arr[i]);
  return a;
}

export { mergeById, uniqueArray2 };
